import classNames from 'classnames';
import { PortableTextBlock } from 'sanity';
import RichText from 'src/components/richtext/Richtext';
import styles from './Ingress.module.css';

//#region [Props]
type IngressProps = {
	className?: string;
	ingress?: PortableTextBlock[],
};
//#endregion

//#region [Component]
export default function Ingress({ className, ingress }: IngressProps) {
	return <RichText value={ingress} className={classNames(styles.SRichText, className)} />
}
//#endregion